import { FC } from 'react';
import { FormField, TextViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { FieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

/**
 * Custom Text field component for TSP theme.
 *
 * Auto-detects "Step X/Y" pattern at the start of text and renders as a pill badge.
 * Other text renders as section title.
 */
const TspText: FC<FieldProps<FormField<TextViewModel>>> = (props) => {
  const { field } = props;
  const { cssClass, text } = field.model;

  if (!text) {
    return null;
  }

  const stepPattern = /^(Step\s+\d+\/\d+)\s*/i;
  const match = text.match(stepPattern);

  if (match) {
    const stepBadge = match[1];
    const introText = text.replace(stepPattern, '').trim();

    return (
      <div className={classNames('tsp-step-info', cssClass)}>
        <span className="tsp-step-badge">{stepBadge}</span>
        {introText && <span className="tsp-page-intro">{introText}</span>}
      </div>
    );
  }

  return <div className={`tsp-section-title ${cssClass}`.trim()}>{text}</div>;
};

export default TspText;
